import React, { Component, createRef } from "react";
// // Editable
import { success, info, error, warning, clear } from "toastr";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment/moment";
import { categoriTypes, cubeList, process } from "../StaticData.js";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addCubes,
  addMachineOperaterStock,
  getCubeBelts,
  getCubesWithProcessId,
  getProcess,
  getUserApi,
  updateCubes,
  updateFillerStock,
  updateMachineOperatorStocks,
} from "api";
import { type } from "@testing-library/user-event/dist/type";
import { withTranslation } from "react-i18next";

class AssignCubeStockList extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      colVal: 0,
      rowVal: 0,
      isSubmit: false,
      flag: null,
      processList:[],
      usedCylinder: 0,
      beltId: "",
      boilManUserId: props?.location?.query?.data?.boilManUserId
        ? props?.location?.query?.data?.boilManUserId
        : "",
      graderUserId: props?.location?.query?.data?.graderUserId
        ? props?.location?.query?.data?.graderUserId
        : "",
      boilManList: [],
      graderList: [],
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: 1, data: null },
      category: "",
      processId:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data?.processId
          : props?.location?.query?.data?.cubeBelt.processId,
      stockList: [],
      JangadList: [],
      userList: [],
      cylinder1:
        props.location.query && props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 1;
              }
            )
          : props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 1;
              }
            ),
      cylinder2:
        props.location.query && props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 2;
              }
            )
          : props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 2;
              }
            ),
      tray: [],
      notEditableRows1:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            )
          : props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            ),
      notEditableRows2:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            )
          : props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            ),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  setJangadList() {
    this.setState({
      JangadList: this.state.stockList
        .map(x => {
          return { label: x.mainJangadId, value: x.mainJangadId };
        })
        .filter(y => {
          let stockFillerInWardsList = this.state.stockList.filter(
            x => x.mainJangadId == y.value
          )[0].stockFillerInWards;
          let cyclinder1 = this.state.cylinder1.filter(
            a => a.mainJangadId == y.value
          );
          let cyclinder2 = this.state.cylinder2.filter(
            a => a.mainJangadId == y.value
          );
          return stockFillerInWardsList.length ==
            cyclinder1.length + cyclinder2.length
            ? false
            : true;
        }),
    });
  }

  validateTable() {
    for (let i = 0; i < this.state.cylinder1.length; i++) {
      let e = this.state.cylinder1[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  validateTable1() {
    for (let i = 0; i < this.state.cylinder2.length; i++) {
      let e = this.state.cylinder2[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    this.validateTable();
    this.validateTable1();
    const process = await getProcess();
    if(process && process.data) {
      this.setState({
        processList: process.data
      })
    }
    const machineOperator = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000004",
    });
    const boilman = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000005",
    });
    const grader = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000002",
    });
    this.setState({
      userList: machineOperator.data.users,
      boilManList: boilman.data.users,
      graderList: grader.data.users.map(x => {
        return {
          label: x.name,
          value: x.id,
        };
      }),
    });
    if (this.state.props.isEdit == 1) {
      let processId = this.state.props.data.processId;
      let cubeBeltId = this.state.props.data.id;
      const data = await getCubesWithProcessId({
        id: processId,
        cubeBeltId: cubeBeltId,
        fillerId: null,
      });
      this.setState(
        {
          stockList: data.data.fillerStocks,
        },
        () => {
          this.setState(
            {
              JangadList: this.state.stockList.map(x => {
                return { label: x.mainJangadId, value: x.mainJangadId };
              }),
            },
            () => {
              this.setJangadList();
            }
          );
        }
      );
    }
    // const s = await this.getStockList();
  }

  async getCube() {
    const stock = await getCubesWithProcessId({
      id: this.state.processId,
      cubeBeltId: null,
      fillerId: null,
    });
    this.setState(
      {
        JangadList: stock.data.fillerStocks.map(x => {
          return { label: x.mainJangadId, value: x.mainJangadId };
        }),
        stockList: stock.data.fillerStocks,
      },
      () => {
        this.setJangadList();
      }
    );
  }

  deleteRow(rowIndex, name, row, notEditableRows) {
    this.state[name].splice(rowIndex, 1);
    // this.state[notEditableRows].splice(this.state[notEditableRows].indexOf(row.id), 1);
    this.setState(
      {
        [name]: this.state[name].map((x, index) => {
          return {
            ...x,
            id: index + 1,
          };
        }),
        [notEditableRows]: this.state[name].map((x, index) => index + 1),
      },
      () => this.setJangadList()
    );
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let temp = {
        machineId: parseInt(values.machineId),
        remarks: values.remarks,
        cubeBeltId: this.state.props.data.id,
      };

      const data = await addMachineOperaterStock(temp);
      this.props.history.goBack();
    } else {
      let temp = {
        boilManUserId: this.state.boilManUserId,
        stockMachineOperatorInWards: [
          ...this.state.cylinder1,
          ...this.state.cylinder2,
        ].map(x => {
          if (x.graderUserId == null) {
            return {
              ...x,
              graderUserId: x.graderStock.userId,
            };
          }
          return x;
        }),
      };
      const data = await updateMachineOperatorStocks({
        id: this.state.props.data.id,
        data: temp,
      });
      // this.props.history.goBack();
    }
  }

  async reject() {
    const data = await updateCubes({
      id: this.state.props.data.id,
      data: {
        machineOperatorStatus: "R",
      },
    });
    if (data.success) {
      this.state.history.goBack();
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }
  render() {
    document.title = "filler flow";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "Total",
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: "",
        formatter: (cell, row) => {
          return row.mainJangad.name +'-'+ row.stockDataEntryInWard.srNo;
        },
        editable:false
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.mainJangad.category.name;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.assignGraderToFillerInWard.weight;
        },
      },
      {
        dataField: "graderUserId",
        text: `${this.props.t("Grader Name")}`,
        footer: "",
        editable:false,
        editor: {
          type: Type.SELECT,
          options: this.state.graderList,
        },
        formatter: (cell, row) => {
          if (this.state.graderList.length == 0 && row.graderUserId != null) {
            return row.graderUser.name;
          } else if (
            this.state.graderList.length > 0 &&
            row.graderUserId != null
          )
            return this.state.graderList?.filter(
              x => row.graderUserId == x.value
            )[0].label;
          else {
            return row.graderStock.user.name;
          }
        },
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t("Edit Data")}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows1.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows1: [
      //                   ...this.state.notEditableRows1,
      //                   row.id,
      //                 ],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows1: this.state.notEditableRows1.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() =>
      //             this.deleteRow(rowIndex, "cylinder1", row, "notEditableRows1")
      //           }
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button>
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows1.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setJangadList();
      //               this.setState({
      //                 notEditableRows1: [
      //                   ...this.state.notEditableRows1,
      //                   row.id,
      //                 ],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows1: this.state.notEditableRows1.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() =>
      //             this.deleteRow(rowIndex, "cylinder1", row, "notEditableRows1")
      //           }
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button>
      //       </div>
      //     );
      //   },
      // },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: false,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.JangadList,
        },
        formatter: (cell, row) => {
          if (cell && this.state.stockList.length) {
            row.category = this.state.stockList.filter(
              x => x.mainJangadId == row.mainJangadId
            )[0].mainJangad.category.name;
          }
          if (cell == "") {
            return "NONE";
          } else {
            return cell;
          }
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.mainJangad.category.name;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.assignGraderToFillerInWard.weight;
        },
      },
      {
        dataField: "graderUserId",
        text: `${this.props.t("Grader Name")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.graderList,
        },
        formatter: (cell, row) => {
          if (this.state.graderList.length == 0 && row.graderUserId != null) {
            return row.graderUser.name;
          } else if (
            this.state.graderList.length > 0 &&
            row.graderUserId != null
          )
            return this.state.graderList?.filter(
              x => row.graderUserId == x.value
            )[0].label;
          else {
            return row.graderStock.user.name;
          }
        },
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows2.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: [
                        ...this.state.notEditableRows2,
                        row.id,
                      ],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: this.state.notEditableRows2.filter(
                        x => x != row.id
                      ),
                    });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                className="bg-transparent border-0 ms-3"
                onClick={() =>
                  this.deleteRow(rowIndex, "cylinder1", row, "notEditableRows2")
                }
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows2.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setJangadList();
                    this.setState({
                      notEditableRows2: [
                        ...this.state.notEditableRows2,
                        row.id,
                      ],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: this.state.notEditableRows2.filter(
                        x => x != row.id
                      ),
                    });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                className="bg-transparent border-0 ms-3"
                onClick={() =>
                  this.deleteRow(rowIndex, "cylinder2", row, "notEditableRows2")
                }
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
      },
    ];

    document.title = "add party";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("Edit Filling Process (Belt)")}`}
            />
            <Formik
              enableReinitialize={true}
              initialValues={
                this.state.props.isEdit == 1
                  ? {
                      beltId: this.state.props.data.cubeId,
                      processId: this.state.props.data.processId,
                      usedCylinder: this.state.props.data.usedCylinder,
                      machineOperatorId:
                        this.state.props.data.machineOperatorId,
                      machineId: "",
                      remarks: this.state.props.data.remarks,
                    }
                  : {
                      beltId: this.state.props.data.cubeBelt.cubeId,
                      processId: this.state.props.data.cubeBelt.processId,
                      usedCylinder: this.state.props.data.cubeBelt.usedCylinder,
                      machineOperatorId:
                        this.state.props.data.cubeBelt.machineOperatorId,
                      // graderUserId: this.state.graderUserId,
                      boilManUserId: this.state.boilManUserId,
                      machineId: this.state.props.data.machineId,
                      remarks: this.state.props.data.cubeBelt.remarks,
                    }
              }
              validationSchema={Yup.object().shape({
                beltId: Yup.string().notRequired(),
                processId: Yup.string().required("This Value is Required"),
                usedCylinder: Yup.string().required("This Value is Required"),
                machineId: Yup.string().required("This Value is Required"),
                machineOperatorId: Yup.string().nullable().notRequired(),
                // graderUserId: Yup.string().nullable().required("This Value is Required"),
                boilManUserId: Yup.string()
                  .nullable()
                  .required("This Value is Required"),
                remarks: Yup.string().max(512).nullable().notRequired(),
              })}
            >
              {({ errors, status, touched, isValid, values, validateForm }) => (
                <Form className="needs-validation">
                  <Card className="px-4">
                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("Edit Filling Process (Belt)")}
                        </h4>
                      </div>
                      {/* <div className="mb-3 row ">
                        <label
                          htmlFor="date"
                          className="col-12 col-sm-2 col-lg-4"
                        >
                          <h5 className="fs-5 fw-bold text-black">Date:</h5>
                        </label>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <input
                            className="border-0 fs-5"
                            type="date"
                            name="date"
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="beltId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Belt Id")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.beltId && touched.beltId
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          name="beltId"
                          type="text"
                          placeholder="Enter Belt Id"
                        />
                        <ErrorMessage
                          name="beltId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="processId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Assign Process")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.processId && touched.processId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.processId}
                          onChange={e => {
                            this.setState(
                              {
                                cylinder1: [],
                                cylinder2: [],
                                notEditableRows1: [],
                                notEditableRows2: [],
                                JangadList: [],
                                stockList: [],
                                processId: e.target.value,
                              },
                              () => this.getCube()
                            );
                          }}
                          disabled={true}
                          name="processId"
                          as="select"
                          defaultValue=""
                        >
                          {this.state.processList?.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="processId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="machineOperatorId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Machine Operator")}
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.machineOperatorId &&
                            touched.machineOperatorId
                              ? " is-invalid"
                              : "")
                          }
                          name="machineOperatorId"
                          as="select"
                          disabled={true}
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.userList.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="machineOperatorId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="machineId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">Machine</h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.machineId && touched.machineId
                              ? " is-invalid"
                              : "")
                          }
                          name="machineId"
                          as="select"
                          disabled={true}
                        >
                          <option value="" disabled>
                            select
                          </option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </Field>
                        <ErrorMessage
                          name="machineId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="remarks"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Filler Notes")}
                        </h5>
                      </Label>
                      <div className="col-md-10">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.remarks && touched.remarks
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          type="text"
                          name="remarks"
                          as="textarea"
                          rows="5"
                          placeholder="Please Take of HPHT First Priority"
                          disabled={true}
                        />
                        <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="boilManUserId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Boil Man Name")}
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.boilManUserId && touched.boilManUserId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.boilManUserId}
                          onChange={e => {
                            this.setState({
                              boilManUserId: e.target.value,
                            });
                          }}
                          name="boilManUserId"
                          as="select"
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.boilManList.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="boilManUserId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <Label
                        htmlFor="graderUserId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                        Grader Name
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.graderUserId &&
                            touched.graderUserId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.graderUserId}
                          onChange={(e) => {
                            this.setState({
                              graderUserId: e.target.value
                            })
                          }}
                          name="graderUserId"
                          as="select"
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.graderList.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="graderUserId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div> */}

                    <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {/* {this.props.t("First Cylinder Kit")} */}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        data={this.state.cylinder1}
                        columns={this.columns1}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: () => {
                            this.setJangadList();
                            this.setState({
                              cylinder1: [...this.state.cylinder1],
                            });
                          },
                          // nonEditableRows: () => this.state.notEditableRows1,
                        })}
                      />
                    </div>
                    {/* <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {this.props.t("Second Cylinder Kit")}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        data={this.state.cylinder2}
                        columns={this.columns2}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          nonEditableRows: () => this.state.notEditableRows2,
                        })}
                      />
                    </div> */}
                    <div className="col-md-12 text-center text-md-end my-4 pe-lg-3">
                      {this.state.props.isEdit == 1 && (
                        <>
                          <Button
                            color="white"
                            className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            Accept
                          </Button>
                          <Button
                            color="primary"
                            onClick={() => this.reject(event, values)}
                            className="fs-4 px-5"
                          >
                            Reject
                          </Button>
                        </>
                      )}
                      {this.state.props.isEdit == 2 && (
                        <>
                          <Button
                            color="primary"
                            onClick={() => {
                              this.props.history.goBack();
                            }}
                            className="fs-4 px-5 me-2"
                          >
                            Back
                          </Button>
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            {this.state.boilManUserId ? "Update" : "Assign"}
                          </Button>
                        </>
                      )}
                      {this.state.props.isEdit == 3 && (
                        <Link to="/filler-dashboard">
                          <Button color="primary" className="fs-4 px-5">
                            Back
                          </Button>
                        </Link>
                      )}
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(AssignCubeStockList);
